import { APP_COOKIEBOT_ID, APP_COOKIEBOT_URL } from 'src/config'
import ClarityPlugin from './clarity'

interface CookiebotConsentsType {
  consent: {
    statistics: boolean
    marketing: boolean
    necessary: boolean
    preferences: boolean
  }
}

const addInlineJS = (file: string, selector = '', params: any | null = null) => {
  if (!selector) {
    selector = `script[src="${file}"]`
  }

  if (document.querySelector(selector) === null) {
    const script = document.createElement('script')
    document.body.appendChild(script)

    if (params != null) {
      Object.keys(params).forEach((key: string) => script.setAttribute(key, (params as any)[key]))
    }

    script.src = file
  }
}

class CookiebotPlugin {
  clarity: any

  constructor() {
    this.clarity = new ClarityPlugin()
  }

  init(): void {
    if (APP_COOKIEBOT_ID) {
      addInlineJS(APP_COOKIEBOT_URL, '', {
        id: 'Cookiebot',
        'data-cbid': APP_COOKIEBOT_ID,
        type: 'text/javascript',
        async: true
      })
    }

    this.events()
  }

  getConsents(): CookiebotConsentsType {
    const cookiebotConsents: CookiebotConsentsType = (window as any).Cookiebot || {}
    return cookiebotConsents
  }

  events(): void {
    // Accept dialog button
    window.addEventListener(
      'CookiebotOnAccept',
      function() {
        // Do something
      },
      false
    )

    // The event is triggered at the same time as the window.onload event when the userâ€™s consent has been loaded
    window.addEventListener(
      'CookiebotOnLoad',
      () => {
        // Do something
      },
      false
    )

    // The event is triggered when the userâ€™s consent state is ready
    window.addEventListener(
      'CookiebotOnConsentReady',
      () => {
        if (this.checkStatisticsConsent()) {
          this.clarity.init()
          this.clarity.consent()
        }
      },
      false
    )
  }

  checkStatisticsConsent(): boolean {
    const cookiebotConsents = this.getConsents()
    return cookiebotConsents.consent && cookiebotConsents.consent.statistics
  }
}

export default CookiebotPlugin
